import { render, staticRenderFns } from "./ManterProcuradorEditar.vue?vue&type=template&id=b2b181be&scoped=true&"
import script from "./ManterProcuradorEditar.vue?vue&type=script&lang=js&"
export * from "./ManterProcuradorEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b181be",
  null
  
)

export default component.exports